module.exports = __webpack_public_path__ + "static/media/advantages-banner.a6455437.png";